import React from 'react';

import BaseSkeleton from '../BaseSkeleton';

const BottomSheetSkeleton: React.FC = () => {
  return (
     <div className='flex flex-column ml4'>
        <BaseSkeleton className="mb2" width={90} />
        <BaseSkeleton className="mb1" width={120}/>
        <BaseSkeleton className="mb1" width={100} />
        <BaseSkeleton className="mb1" />
        <BaseSkeleton className="mb1" width={70} />
        <BaseSkeleton className="mb1" />
    </div>
  );
};

export default BottomSheetSkeleton;
